import React from "react";
import { firestore } from "../firebase/config";
import { MyUser, UserContextType } from "../libs/Interfaces";
import { useAuth } from "./AuthContext";

const dummyUser: MyUser = {
    id: 'invalidid',
    email: 'invalidemail',
    latitude: 0,
    longitude: 0,
    mobileNumber: 'invalidnumber',
    followersCount: 0,
    followingCount: 0,
    image: 'invalidimage',
    isArtist: false,
    name: 'invalidname'
};

const UserContext = React.createContext<UserContextType>({
    user: dummyUser,
    update: console.log
});

export function useUser() {
    return React.useContext(UserContext);
}

export function UserProvider({ children }: { children: any }) {

    const { currentUser } = useAuth();
    const [user, setUser] = React.useState<MyUser>(dummyUser);

    async function initialise(authuser?:firebase.default.User|null) {
        if (!authuser) authuser = currentUser;
        if (authuser === null) return setUser(dummyUser);
        let uid = authuser.uid;
        let data_public = await firestore.collection("users").doc(uid).collection("public").doc("data").get({
            source: "default"
        });
        let data_private = await firestore.collection("users").doc(uid).collection("private").doc("data").get({
            source: "default"
        });
        let userdata = {
            ...data_public.data(),
            ...data_private.data()
        };
        if (userdata) setUser(userdata as MyUser);
    };

    function update() {
        return initialise();
    }

    React.useEffect(() => {
        initialise(currentUser);
    }, [currentUser]);

    const value: UserContextType = {
        user,
        update
    };

    return (
        <UserContext.Provider value={value}>
            {children}
        </UserContext.Provider>
    );
}